export const serverbaselink = 'https://tabexsystem.tabex.clinic';
// export const serverbaselink = 'http://127.0.0.1:8000';
